__turbopack_context__.v({
  "SFilmwebSGLogoSvg": "_3Ldrma_SFilmwebSGLogoSvg",
});
